export default "__VITE_ASSET__f0c19735__"